export const isIE =
  !!document.documentMode ||
  navigator.userAgent.indexOf('MSIE') != -1 ||
  !!navigator.userAgent.match(/Trident.*rv:11\./);
export const isEdge =
  (!isIE && !!window.StyleMedia) || !!navigator.userAgent.match(/edge\/(\d+)/);
export const scrollPage = (id, offset) =>
  id.offsetHeight + id.offsetTop - offset;
